import React from 'react';
import {
  FaFunnelDollar,
  FaChartLine,
  FaUsers,
  FaMobileAlt,
  FaSync,
  FaShieldAlt,
  FaCheckCircle,
} from 'react-icons/fa';

const features = [
  {
    icon: <FaFunnelDollar className="w-6 h-6" />,
    title: 'High-Converting Funnels',
    description:
      'Create beautiful, mobile-optimized funnels that convert visitors into leads and customers with our drag-and-drop editor.',
    color: 'blue',
  },
  {
    icon: <FaChartLine className="w-6 h-6" />,
    title: 'Advanced Analytics',
    description:
      'Track every interaction with detailed analytics and conversion metrics to optimize your marketing campaigns.',
    color: 'green',
  },
  {
    icon: <FaUsers className="w-6 h-6" />,
    title: 'Lead Management',
    description:
      'Easily manage and nurture your leads with our intuitive CRM designed specifically for automotive sales.',
    color: 'purple',
  },
  {
    icon: <FaMobileAlt className="w-6 h-6" />,
    title: 'Mobile-First Design',
    description:
      'All funnels are automatically optimized for mobile devices, ensuring a seamless experience for every visitor.',
    color: 'red',
  },
  {
    icon: <FaSync className="w-6 h-6" />,
    title: 'Automated Workflows',
    description:
      'Save time with automated follow-ups, lead scoring, and personalized customer journeys.',
    color: 'yellow',
  },
  {
    icon: <FaShieldAlt className="w-6 h-6" />,
    title: 'Secure & Reliable',
    description:
      'Enterprise-grade security and 99.9% uptime guarantee to keep your data safe and your business running smoothly.',
    color: 'indigo',
  },
  {
    icon: <FaCheckCircle className="w-6 h-6" />,
    title: 'Guaranteed Revenue Growth',
    description:
      'We deliver guaranteed revenue growth with a guaranteed close rate that delivers revenue and profits.',
    color: 'teal',
  },
];

const Features = () => {
  return (
    <section className="py-[100px] bg-white" id="features">
      <div className="container mx-auto px-4">
        <div className="text-center mb-[60px]">
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
            Powerful Features for Automotive Success
          </h2>
          <p className="text-lg text-gray max-w-[700px] mx-auto">
            Everything you need to generate qualified leads, improve conversion rates, and boost
            your dealership's performance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl hover:-translate-y-2.5 transition-all duration-300 p-[30px]"
            >
              <div className="w-[60px] h-[60px] bg-primary-light/20 rounded-xl flex items-center justify-center mb-5">
                <span className="text-primary text-2xl">
                  {feature.icon}{' '}
                  {/* Assuming icon components are 24px by default from react-icons, text-2xl will enforce it */}
                </span>
              </div>
              <h3 className="text-xl font-semibold text-dark mb-2.5">{feature.title}</h3>
              <p className="text-gray leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="#pricing"
            className="inline-block px-8 py-3 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors duration-300"
          >
            See All Features
          </a>
        </div>
      </div>
    </section>
  );
};

export default Features;
